import styles from './styles.module.css';
import { NavLink } from 'react-router-dom';
import { displayBanner } from 'volto-gdpr-privacy';
import { useDispatch } from 'react-redux';

export default function FirstSubfooter() {
  const dispatch = useDispatch();

  return (
    <section
      className={styles.first_subfooter}
      aria-label="Contacts and legal info links"
    >
      <ul>
        <li>
          <NavLink to="/sds-forms">SDS Forms</NavLink>
        </li>
        <li>
          <NavLink to="/whisteblowing">Whistleblowing Report</NavLink>
        </li>
        <li>
          <NavLink to="/privacy-policy">Privacy Policy</NavLink>
        </li>
        <li>
          <NavLink to="/cookie-policy">Cookie Policy</NavLink>
        </li>
        <li>
          <button
            className={styles.footer_gdpr_privacy_show_banner}
            onClick={(e) => {
              e.preventDefault();
              dispatch(displayBanner(true, true));
            }}
          >
            Cookie Settings
          </button>
        </li>
        <li>
          <NavLink to="/cvd-policy">Coordinated Vulnerability Disclosure Policy</NavLink>
        </li>
      </ul>
    </section>
  );
}
